//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "../../blue-search/transitions/Expand.vue";

export default {
  props: ['filters', 'executeSearch', 'setFilterValue', 'filtergroup', 'filter', 'isChild', 'parentFilter'],
  name: 'Item',
  data() {
    return {
      active: false,
      expandTimer: null
    }
  },
  components: { TransitionExpand },
  computed: {
    hasChildren(){
      return !!(this.filter && Array.isArray(this.filter.filters) && this.filter.filters.length);
    },
    shouldShowFilter() {
      // For child filters, only show if they have count > 0 or are selected
      if (this.isChild) {
        return this.filter.count > 0 || this.model;
      }
      // For parent filters, show if they have count > 0, are selected, or have children with results
      if (this.hasChildren) {
        return this.filter.count > 0 || this.model || this.hasDescendantWithCount(this.filter);
      }
      // For regular filters, show if they have count > 0 or are selected
      return this.filter.count > 0 || this.model;
    },
    visibleChildren() {
      // Filter children to only show those with count > 0 or selected
      if (!this.hasChildren || !this.filter.filters) {
        return [];
      }
      return this.filter.filters.filter(child => 
        child.count > 0 || child.selected
      );
    },
    model:{
      get() {
        return this.filter.selected;
      },
      set(value) {
        this.setFilterValues(this.filter, value);
        if (value && this.parentFilter && this.parentFilter.selected !== true) {
          // ensure parent is also selected when a child is selected
          this.setFilterValues(this.parentFilter, true);
        }
      },
    },
    label() {
      if(this.options.setFiltersCount == true){
        return `${this.filter.value} (${this.filter.count})`;
      }
      else{
        return `${this.filter.value}`;
      }
    }
  },
   methods: {
    hasDescendantWithCount(filter) {
      if (!filter || !filter.filters || !filter.filters.length) {
        return false;
      }
      // Check if any child has count > 0 or is selected, or recursively check their children
      return filter.filters.some(child => 
        child.count > 0 || 
        child.selected || 
        this.hasDescendantWithCount(child)
      );
    },
    onLabelClick(event){
      if (this.hasChildren) {
        this.toggleExpand(event);
      } else {
        this.setFilterValues(this.filter, !this.filter.selected);
      }
    },
    toggleExpand(event){
      this.active = !this.active;
      const selected = this.active;
      if (this.expandTimer) clearTimeout(this.expandTimer);
      this.expandTimer = setTimeout(() => {
        this.setFilterValues(this.filter, selected);
      }, 500);
      if (event && event.target && event.detail > 0) {
        event.target.blur();
      }
    },
    setFilterValues (filter, val)  {
      let value;
      if (typeof val === "object") value = val.target.value;
      else value = val;
      this.setFilterValue(filter, value);
    }
  },
  created(){
    if(this.hasChildren){
      const recurse = (items) => items.some(i => i.selected || (i.filters && i.filters.length && recurse(i.filters)));
      if(this.filter.selected || recurse(this.filter.filters)){
        this.active = true;
      }
    }
  },
  watch: {
    'filter.selected'(val){
      if (this.hasChildren && val) {
        this.active = true;
      }
    }
  }
}

